import React, { useContext } from "react";
import { FormControl, FormControlLabel, FormLabel, Radio, RadioGroup } from "@mui/material";
import GroupBDRBiologists from "../FieldTags/GroupBDRBiologists";
import { UserContext } from "../../context/UserContext";
import xplanLabels from "../../util/XplanLabels";
import ROLES from "../../util/roles";
import HistoryLogElement from "./HistoryLogElement";
import { checkRole } from "../../util/FormUtils";

const newPlan = window.location.pathname === "/xplans/new";

const ExperimentType = ({ experimentType, handleChange, xplans, required }) => {
    const { user } = useContext(UserContext);
    const canEdit = checkRole(user, [ROLES.BIOLOGIST, ROLES.APPROVER]);

    return (
        <div id="experimentType" className="planField">
            <GroupBDRBiologists />
            <FormControl required={required.includes("experimentType")}>
                <FormLabel className="planRadioTitle">
                    {xplanLabels.experimentType}
                </FormLabel>
                <RadioGroup
                    name="experimentType"
                    label={xplanLabels.experimentType}
                    value={experimentType}
                    onChange={(e) => handleChange("experimentType", e.target.value)}
                    row
                >
                    <FormControlLabel
                        value="Protocol Specified Studies"
                        control={<Radio disabled={!canEdit} />}
                        label="Protocol Specified Studies"
                    />
                    <FormControlLabel
                        value="Future Studies"
                        control={<Radio disabled={!canEdit} />}
                        label="Future Studies"
                    />
                </RadioGroup>
            </FormControl>
            {!newPlan && <HistoryLogElement xplans={xplans} label={"experimentType"} />}
        </div>
    );
};

export default ExperimentType;